import axios from "axios";

import ENV from "../../util/env-config";
import { getSessionCookie } from "../../util/common";

class Service {
  static requestConfig() {
    return {
      headers: {
        Authorization: `Bearer ${getSessionCookie()}`,
        Pragma: "no-cache",
      },
    };
  }

  static getTemplates() {
    return axios.get(ENV.dealerBaseUrl + "/report_templates/list", this.requestConfig());
  }

  static assignTemplate(requestData) {
    return axios.post(ENV.dealerBaseUrl + "/report_templates/assign", requestData, this.requestConfig());
  }
}

export default Service;
